import { observer } from 'mobx-react-lite'
import { type ReactNode } from 'react'
import classNames from 'classnames'
import { Typography } from 'shared/ui'
import { usePresentationModeContext } from 'widgets/PresentationMode'
import styles from './styles.module.scss'

type Props = {
  leftActions?: ReactNode
  centerActions?: ReactNode
  rightActions?: ReactNode
  middleContent?: ReactNode
}

export const InfoWrap = observer(
  ({ leftActions, centerActions, rightActions, middleContent }: Props) => {
    const presentationStore = usePresentationModeContext()
    const onMouseEnter = () => {
      presentationStore.setDisabledOverlayClick(true)
    }
    const onMouseLeave = () => {
      presentationStore.setDisabledOverlayClick(false)
    }
    return (
      <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        <div className={styles.header}>
          <Typography variant={'body-md-regular'} ellipsis ariaLabel={'name'}>
            {presentationStore.currentAttachment?.name}
          </Typography>
        </div>
        {(middleContent && <div className={styles.middleContent}>{middleContent}</div>) || (
          <div className={styles.divider} />
        )}
        <div className={styles.footer}>
          <div className={classNames(styles.flex, styles.left)}>{leftActions}</div>
          <div className={classNames(styles.flex, styles.center)}>{centerActions}</div>
          <div className={classNames(styles.flex, styles.right)}>{rightActions}</div>
        </div>
      </div>
    )
  }
)
